<tran-application-detail-dashboard-box>
    <ng-container body>
        @if (isLoading()) {
            <div class="flex flex-col gap-3" aria-hidden="true">
                <span class="si-skeleton w-20"></span>
                <span class="si-skeleton w-24"></span>
            </div>
        } @else if (readonly()) {
            <tran-dashboard-tile
                class="w-full h-full"
                icon="element-timer"
                unit="h"
                property="application-detail.learning-hours-per-person"
                [kpi]="value() || undefined"
            />
        } @else {
            <si-form-item
                [label]="'application-detail.learning-hours-per-person' | translate"
                [formErrorMapper]="{
                    required: 'application-form.required' | translate,
                    min: 'application-form.number-min1' | translate
                }"
            >
                <tran-number-input
                    class="form-control"
                    [formControl]="effectiveControl()"
                    [disabled]="readonly() || effectiveControl().disabled"
                    [min]="0"
                    [step]="10"
                    [placeholder]="'application-form.example-2' | translate"
                />
            </si-form-item>
        }
    </ng-container>
</tran-application-detail-dashboard-box>
